import React from 'react';

import { Card } from 'components/blocks';

import { ISCBCardSlider } from 'types/interfaces/sulu/IContentBlocks';

import Slider from '../primitives/Slider';
import Reveal from './Reveal';

export default ({ title, cards, has_orchid_theme }: ISCBCardSlider) => (
  <div>
    {title && (
      <Reveal>
        <h2
          className={`text-center mb-9 ${
            has_orchid_theme ? 'text-orchid' : ''
          }`}
        >
          {title}
        </h2>
      </Reveal>
    )}
    <Slider>
      {cards.map(card => (
        <Card
          key={card.id}
          {...card.content}
          has_orchid_theme={has_orchid_theme}
        />
      ))}
    </Slider>
  </div>
);
